// ANNOUNCEMENT COUNTDOWN -- START
$(document).ready(function () {
  var timerEl = $('.limited-sale .sale-timer');
  var globalTimerEl = $('.timer-pdp-and-cart-offers');

  if (globalTimerEl.length > 0) {
    var targetTimeStr = globalTimerEl.attr('data-end-time'); // ISO format
    var targetTime = new Date(targetTimeStr).getTime();

    var countdownInterval = setInterval(function () {
      var currentTime = new Date().getTime();
      var timeRemaining = targetTime - currentTime;

      if (timeRemaining <= 0) {
        clearInterval(countdownInterval);
        timerEl.hide(); // Or show expired message
      } else {
        var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        timerEl.find('.sale-day span').text(days);
        timerEl.find('.sale-hour span').text(hours);
        timerEl.find('.sale-minute span').text(minutes);
        timerEl.find('.sale-second span').text(seconds);
      }
    }, 1000);
  }
});
// ANNOUNCEMENT COUNTDOWN -- END

// HERO BANNER -- START

jQuery(document).ready(function($) {
  $('.hero_slider_banner').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.hero_slider_content'
  });
  $('.hero_slider_content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical:false,
      asNavFor: '.hero_slider_banner',
      fade: true,
      dots: false,
      arrows: true,
      prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.3966 22.2579L0.182922 11.5128L11.3966 0.767792V22.2579Z" fill="#333333"/></svg></button>',
      nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg width="12" height="23" viewBox="0 0 12 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.601757 0.767831L11.8154 11.5129L0.601755 22.2579L0.601757 0.767831Z" fill="#333333"/></svg></button>',
      focusOnSelect: true,
      verticalSwiping:false
  });
});

// HERO BANNER -- END

// REVIEW SLIDER -- START

jQuery(document).ready(function($) {
  $('.review__slider').slick({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    loop: false,
    arrows: true,
    prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button"><svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.006 512.006" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g></svg></button>',
    nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button"><svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512.005 512.005" xml:space="preserve"><g><g><path d="M388.418,240.923L153.751,6.256c-8.341-8.341-21.824-8.341-30.165,0s-8.341,21.824,0,30.165L343.17,256.005 L123.586,475.589c-8.341,8.341-8.341,21.824,0,30.165c4.16,4.16,9.621,6.251,15.083,6.251c5.461,0,10.923-2.091,15.083-6.251 l234.667-234.667C396.759,262.747,396.759,249.264,388.418,240.923z"/></g></g></svg></button>',
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
         breakpoint: 750,
         settings: {
            slidesToShow: 2,
            slidesToScroll: 1
         }
      },
      {
         breakpoint: 450,
         settings: {
            centerMode: true,
            centerPadding:'30px',
            slidesToShow: 1,
            slidesToScroll: 1
         }
      }
    ]
  });
});

// REVIEW SLIDER -- END